// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import pt from 'prop-types';
import classNames from 'classnames';
import React, { useEffect } from 'react';

import { formValidators } from '@ion/components';
import { MrH, MrInputText } from '@ion/components';
import FeatureGate from '@ion/app/src/launch-darkly/gates/feature-gate';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import styles from './index.module.scss';
import { GatedConsentCategoriesSelect } from '../consent-categories-select/GatedConsentCategoriesSelect';

const { validateCsvUrls, validateRequired } = formValidators;

const AnalyticsBuilderCrossDomainDirect = ({
  formState,
  setField,
  validateField,
  resetError,
  crossDomainV1Enabled,
}) => {
  const consentCategorySelectName = `sync-crossDomainDirect-consentCategoryId`;
  const isCrossDomainDirectValueEmpty = formState.crossDomainDirect?.value === '';
  useEffect(() => {
    if (isCrossDomainDirectValueEmpty) {
      setField({
        target: {
          name: 'sync-crossDomainDirect-consentCategoryId',
          value: '',
        },
      });
    }
  }, [setField, isCrossDomainDirectValueEmpty]);
  return (
    <FeatureGate flagName={FEATURE_FLAGS.crossDomainDirect}>
      <section id="section" className={styles.section}>
        <MrH h="h5" sans styleNames="noMargin">
          <div className={styles.circle}>{crossDomainV1Enabled ? 5 : 4}</div> Cross-Domain-Direct Identity Sync
        </MrH>
        <p className={styles.headerHelperText}>
          Add the cluster URL where this file will sync to. This will maintain a common user identifier (identifier key)
          among all of the domains you have configured to use cross-domain. This is usually an A record mapped to the
          ingestor cluster URL.
        </p>
        <div className={styles.subSection}>
          <MrInputText
            onChange={setField}
            value={formState.crossDomainDirect?.value}
            placeholder={'https://ingest.domain-1.com'}
            onBlur={validateField}
            onInput={resetError}
            name="crossDomainDirect"
            errorMsg={formState.crossDomainDirect?.errorMsg}
            helperText='Cluster URL must include "https://"'
            validators={isCrossDomainDirectValueEmpty ? [] : [validateCsvUrls()]}
            fullWidth
          />
        </div>
        <FeatureGate flagName={FEATURE_FLAGS.configurableConsentMvp}>
          <div className={classNames([styles.subSection, styles.marginTop])}>
            <MrH h="h5" styleNames="noMargin" sans>
              Consent Type
            </MrH>
            <div className={styles.marginTop}>
              <GatedConsentCategoriesSelect
                errorMsg={formState[consentCategorySelectName]?.errorMsg}
                onChange={setField}
                value={formState[consentCategorySelectName]?.value}
                name={consentCategorySelectName}
                validators={isCrossDomainDirectValueEmpty ? [] : [validateRequired()]}
                onBlur={validateField}
                onInput={resetError}
                disabled={isCrossDomainDirectValueEmpty}
                deprecatedSelect
              />
            </div>
          </div>
        </FeatureGate>
      </section>
    </FeatureGate>
  );
};

AnalyticsBuilderCrossDomainDirect.propTypes = {
  formState: pt.object,
  setField: pt.func,
  validateField: pt.func,
  resetError: pt.func,
  crossDomainV1Enabled: pt.bool,
};

export default AnalyticsBuilderCrossDomainDirect;
